import Http from '../../../common/http';

const saveFilter = (url, kind, data, goodCallback, badCallback) => {
  Http.post(url, { settings: { [kind]: data } }).then(
    (response) => {
      if (response.response.ok) {
        goodCallback && goodCallback(response);
      } else {
        badCallback && badCallback(response);
      }
    },
    (response) => {
      console.log('something went wrong', response);
    }
  );
};

const reportRequest = (url, params, goodCallback, badCallback) => {
  Http.post(url, params).then(
    (response) => {
      if (response.response.ok) {
        goodCallback && goodCallback(response);
      } else {
        badCallback && badCallback(response);
      }
    },
    (response) => {
      console.log('something went wrong', response);
    }
  );
};

const changeConceptRequest = (url, params, goodCallback, badCallback, finalActions) => {
  Http.get(url, params).then(
    (response) => {
      if (response.response.ok) {
        goodCallback && goodCallback(response);
      } else {
        badCallback && badCallback(response);
      }
      finalActions && finalActions(response);
    },
    (response) => {
      console.log('something went wrong', response);
      finalActions && finalActions(response);
    }
  );
};

const saveUserSettingsRequest = (url, params, goodCallback, badCallback) => {
  Http.post(url, { settings: params }).then(
    (response) => {
      if (response.response.ok) {
        goodCallback && goodCallback(response);
      } else {
        badCallback && badCallback(response);
      }
    },
    (response) => {
      console.log('something went wrong', response);
    }
  );
};

const updateRegionRequest = (url, params, goodCallback, badCallback) => {
  Http.put(url, { region: params }).then(
    (response) => {
      if (response.response.ok) {
        goodCallback && goodCallback(response);
      } else {
        badCallback && badCallback(response);
      }
    },
    (response) => {
      console.log('something went wrong', response);
    }
  );
};

const deleteRegionRequest = (url, goodCallback, badCallback) => {
  Http.del(url).then(
    (response) => {
      if (response.response.ok) {
        goodCallback && goodCallback(response);
      } else {
        badCallback && badCallback(response);
      }
    },
    (response) => {
      console.log('something went wrong', response);
    }
  );
};

const createRegionRequest = (url, params, goodCallback, badCallback) => {
  Http.post(url, { region: params }).then(
    (response) => {
      if (response.response.ok) {
        goodCallback && goodCallback(response);
      } else {
        badCallback && badCallback(response);
      }
    },
    (response) => {
      console.log('something went wrong', response);
    }
  );
};

const saveSettingsRequest = (url, params, goodCallback, badCallback) => {
  Http.post(url, { settings: params }).then(
    (response) => {
      if (response.response.ok) {
        goodCallback && goodCallback(response);
      } else {
        badCallback && badCallback(response);
      }
    },
    (response) => {
      console.log('something went wrong', response);
    }
  );
};

export {
  saveFilter, reportRequest, changeConceptRequest, saveUserSettingsRequest, updateRegionRequest,
  deleteRegionRequest, createRegionRequest, saveSettingsRequest
};
